export const DEFAULT_FIELD_CONFIG = Object.freeze({
  fieldKey: "",
  fieldType: "string",
  label: "",
  name: "",
  sequence: 0,
  group: "",
  fieldGroup: "",
  isRequired: false,
  maxLength: null,
  isNonEditable: false,
  isSystemField: false,
  defaultValue: "",
  options: [],
  effects: [],
  validation: [],
  optionFilter: null,
  fieldSettings: null,
  description: "",
});

export function createFieldConfig(overrides = {}) {
  return {
    ...DEFAULT_FIELD_CONFIG,
    options: [...DEFAULT_FIELD_CONFIG.options],
    effects: [...DEFAULT_FIELD_CONFIG.effects],
    validation: [...DEFAULT_FIELD_CONFIG.validation],
    ...overrides,
  };
}

export { createDerivedState } from "./derivedState";
